/**
 * Selects the current active session from store.
 */
export default state => state.restricted._session.current_session_meta_proxy;



// WEBPACK FOOTER //
// ./src/selectors/currentSession.js